import { ExclamationCircleOutlined, GiftOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { IAddRewardsFormValues } from '../../../utils/commonInterfaces';
interface ConfirmRewardsContentProps {
    pendingValues: IAddRewardsFormValues;
    userInfo: any;
    rewardsAmountDisplay: string;
}

export const ConfirmRewardsContent = ({
    pendingValues,
    userInfo,
    rewardsAmountDisplay,
}: ConfirmRewardsContentProps) => (
    <div className="px-1 py-2">
        <div className="flex flex-col items-center mb-6 text-center">
            <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full shadow-inner bg-gradient-to-br from-amber-100 via-orange-50 to-amber-200">
                <GiftOutlined className="text-3xl text-amber-500" />
            </div>
            <h3 className="mb-1 text-lg font-semibold text-slate-800">
                Confirm Rewards Addition
            </h3>
            <p className="text-sm text-slate-500">
                Review the details below before confirming
            </p>
        </div>

        <div className="p-5 mb-5 border rounded-xl border-amber-100 bg-gradient-to-b from-amber-50/90 to-white">
            <p className="mb-5 text-base leading-relaxed text-center text-slate-700">
                Rewards of the amount{' '}
                <span className="font-bold text-amber-600">
                    {rewardsAmountDisplay}
                </span>{' '}
                will be added to user{' '}
                <span className="font-bold text-blue-600">
                    {userInfo?.userID ?? 'N/A'}
                </span>
                .
            </p>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <div className="rounded-lg border border-slate-100 bg-white/90 px-3 py-2.5">
                    <span className="mb-0.5 block text-xs uppercase tracking-wide text-slate-400">
                        Full Name
                    </span>
                    <span className="font-medium text-slate-700">
                        {userInfo?.name || 'N/A'}
                    </span>
                </div>
                <div className="rounded-lg border border-slate-100 bg-white/90 px-3 py-2.5">
                    <span className="mb-0.5 block text-xs uppercase tracking-wide text-slate-400">
                        Phone
                    </span>
                    <span className="font-medium text-slate-700">
                        {userInfo?.phone || 'N/A'}
                    </span>
                </div>
                <div className="rounded-lg border border-slate-100 bg-white/90 px-3 py-2.5">
                    <span className="mb-0.5 block text-xs uppercase tracking-wide text-slate-400">
                        Rewards Amount
                    </span>
                    <Tag color="gold" className="m-0 px-2.5 py-0.5 text-sm font-semibold">
                        {rewardsAmountDisplay}
                    </Tag>
                </div>
                <div className="rounded-lg border border-slate-100 bg-white/90 px-3 py-2.5">
                    <span className="mb-0.5 block text-xs uppercase tracking-wide text-slate-400">
                        Send SMS
                    </span>
                    <Tag color={pendingValues.sendSms ? 'green' : 'default'} className="m-0">
                        {pendingValues.sendSms ? 'Yes' : 'No'}
                    </Tag>
                </div>
            </div>
        </div>

        <div className="flex items-start gap-3 px-4 py-3 border rounded-lg border-amber-100 bg-amber-50/60">
            <ExclamationCircleOutlined className="mt-0.5 shrink-0 text-lg text-amber-500" />
            <p className="m-0 text-sm leading-relaxed text-slate-600">
                Are you sure you want to proceed? This action will credit the rewards
                balance immediately.
            </p>
        </div>
    </div>
);
